//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"Active",1,0],[0,"AlignmentMethod",1,0],[1,"BackAngleExp",0,"Expression",0],[0,"Description",1,0],[0,"HandCenterPoint",1,"Point",0],[0,"HandCenterPointActive",1,0],[0,"HeelReferencePoint",1,"Point",0],[0,"HeelReferencePointActive",1,0],[1,"HorizontalPointTravelExp",0,"Expression",0],[0,"PassengerType",1,0],[1,"SeatAngleExp",0,"Expression",0],[0,"SeatDirection",1,0],[0,"SeatReferencePoint",1,"Point",0],[0,"SeatReferencePointActive",1,0],[0,"TypeStateActive",1,0]],[[["other"],"Assign",{},1,0],[["dValue"],"SetSeatAngle",{},1,1],[[],"GetSeatAngle",{R_:{pValue:''}},0,1],[["dValue"],"SetBackAngle",{},1,1],[[],"GetBackAngle",{R_:{pValue:''}},0,1],[["dValue"],"SetHorizontalPointTravel",{},1,1],[[],"GetHorizontalPointTravel",{R_:{pValue:''}},0,1]],[]];
SPLM.Features.VehicleDesign.BaseDataPassengerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.BaseDataPassengerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.BaseDataPassengerBuilder.SeatDirectionOptions = Object.freeze({
    "Frontward" : "Frontward", "Backward" : "Backward", "Left" : "Left", "Right" : "Right", "Custom" : "Custom"});

SPLM.Features.VehicleDesign.BaseDataPassengerBuilder.PassengerTypeOptions = Object.freeze({
    "Seating" : "Seating", "Standing" : "Standing", "Lying" : "Lying"});

SPLM.Features.VehicleDesign.BaseDataPassengerBuilder.AlignmentMethods = Object.freeze({
    "ProjectPerpendicular" : "ProjectPerpendicular", "ProjectAlongY" : "ProjectAlongY", "RotateAboutSgRP" : "RotateAboutSgRP", "DistanceFromSgRP" : "DistanceFromSgRP"});

export default SPLM;